"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is how you get Layout if you don\'t pass any properties.' +
    ' It has an AppBar, a Drawer and a LayoutBody, that has a gray background color.' +
    ' You can click on default button to toggle the drawer.';
var code = "import React from 'react';\nimport { Layout } from 'jsc-react-ui';\n\nconst Example = () => <Layout />;";
exports.RawExampleLayout = function () { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.Layout, null))); };
exports.RawExampleLayout.displayName = 'RawExampleLayout';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentLayoutPage/RawExampleLayout.tsx
// module id = 690
// module chunks = 0